import { type ReactNode } from "react";

import "./editorPage.css";
import { PageHeader } from "./PageHeader";

/** Shared detail/form frame: navigation above the sheet, actions beside its title. */
export function EditorPage({ className = "", back, actions, heading, children }: {
  className?: string;
  back: ReactNode;
  actions?: ReactNode;
  heading?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className={`editor-page ${className}`}>
      <header className="app-toolbar editor-page-navigation">
        <div className="app-toolbar-title">{back}</div>
        {actions ? <div className="app-toolbar-actions">{actions}</div> : null}
      </header>
      {heading}
      {children}
    </div>
  );
}

export function EditorHeader({ kicker, title, actions, className = "" }: {
  kicker?: ReactNode;
  title: ReactNode;
  actions?: ReactNode;
  className?: string;
}) {
  return <PageHeader className={`editor-header ${className}`} kicker={kicker} title={title} actions={actions} />;
}

export function EditorPanel({ className = "", label, variant = "surface", children }: {
  className?: string;
  label?: string;
  variant?: "surface" | "layout";
  children: ReactNode;
}) {
  return <section className={`panel panel-primary editor-panel${variant === "layout" ? " is-layout" : ""} ${className}`} aria-label={label}>{children}</section>;
}
